
import apiClient from "../../core/apiClient";
import { AgentProducerCode } from "../../interfaces/DTO/agent/agentProducerCode";
import { BaseService } from "../BaseService";

const API_URL = "/agent-producer-codes";

class AgentProducerCodeService extends BaseService<AgentProducerCode> {
  constructor() {
    super(API_URL);
  }

  async fetchAll(): Promise<AgentProducerCode[]> {
    const response = await apiClient.get<AgentProducerCode[]>(API_URL);
    return response.data;
  }
}

export const agentProducerCodeService = new AgentProducerCodeService();
